import { useLiveQuery } from 'dexie-react-hooks'
import { getDb, type MediaRecord } from '@/offline/db'

export type PhotoState = 'SENT' | 'WAITING' | 'LOST' | 'MISSING'

export function photoState(m: MediaRecord | undefined): PhotoState {
  if (!m) return 'MISSING'
  if (m.status === 'UPLOADED') return 'SENT'
  if (m.status === 'LOST') return 'LOST'
  return 'WAITING'
}

/** The photos a record refers to, live: what is on the phone, what reached the server. */
export function useRecordPhotos(ids: string[]) {
  return useLiveQuery(
    async () => {
      const rows = await getDb().media.bulkGet(ids)
      return ids.map((id, i) => ({ id, rec: rows[i], state: photoState(rows[i]) }))
    },
    [ids.join(',')],
    [] as Array<{ id: string; rec: MediaRecord | undefined; state: PhotoState }>,
  )
}
